import { Stack } from '@mui/material';
import React from 'react';
import Skeleton from '@/components/@IntranetLibrary/Skeleton';

const SkeletonItem = () => (
  <Skeleton variant={'rect'} width={'100%'} height={'25px'} />
);

const ApprovalFiltersSkeleton = () => (
  <Stack gap={'16px'} marginTop={'40px'}>
    {[1, 2].map((item) => (
      <SkeletonItem key={item} />
    ))}
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginLeft: '40px',
        marginBottom: '5px',
      }}
    >
      {[1, 2, 3, 4].map((item) => (
        <SkeletonItem key={item} />
      ))}
    </div>
    <SkeletonItem />
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginLeft: '40px',
        marginBottom: '5px',
      }}
    >
      {[1, 2, 3].map((item) => (
        <SkeletonItem key={item} />
      ))}
    </div>
    {[1, 2].map((item) => (
      <SkeletonItem key={item} />
    ))}
    <SkeletonItem />
    <SkeletonItem />
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginLeft: '40px',
        marginBottom: '5px',
      }}
    >
      {[1].map((item) => (
        <SkeletonItem key={item} />
      ))}
    </div>
    {[1, 2].map((item) => (
      <SkeletonItem key={item} />
    ))}
  </Stack>
);

export default ApprovalFiltersSkeleton;
